import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Menu, X, PenSquare, ChevronDown } from 'lucide-react';

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [productsOpen, setProductsOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const products = [
    { to: '/esign', label: 'eSign', desc: 'PDF e-signatures' },
    { to: '/email-signatures', label: 'Email Signatures', desc: 'Animated email sigs' },
    { to: '/social', label: 'Social Animations', desc: 'LinkedIn, Twitter & more' },
    { to: '/ai-images', label: 'AI Images', desc: 'DALL-E 3 generator' },
  ];

  return (
    <nav className="bg-white border-b border-gray-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center gap-2 font-bold text-xl text-blue-600">
            <PenSquare className="w-6 h-6" />
            EZSig
          </Link>

          {/* Desktop nav */}
          <div className="hidden md:flex items-center gap-6">
            <div className="relative" onMouseLeave={() => setProductsOpen(false)}>
              <button
                className="flex items-center gap-1 text-gray-600 hover:text-blue-600 font-medium"
                onMouseEnter={() => setProductsOpen(true)}
              >
                Products <ChevronDown className="w-4 h-4" />
              </button>
              {productsOpen && (
                <div className="absolute top-full left-0 mt-1 w-56 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-50">
                  {products.map(p => (
                    <Link
                      key={p.to}
                      to={p.to}
                      className="block px-4 py-2 hover:bg-gray-50"
                      onClick={() => setProductsOpen(false)}
                    >
                      <div className="font-medium text-gray-800">{p.label}</div>
                      <div className="text-xs text-gray-500">{p.desc}</div>
                    </Link>
                  ))}
                </div>
              )}
            </div>
            <Link to="/pricing" className="text-gray-600 hover:text-blue-600 font-medium">Pricing</Link>
            {user ? (
              <>
                <Link to="/dashboard" className="text-gray-600 hover:text-blue-600 font-medium">Dashboard</Link>
                {user.is_admin && (
                  <Link to="/admin" className="bg-red-600 text-white text-xs font-bold px-3 py-1.5 rounded-lg hover:bg-red-700">
                    Admin
                  </Link>
                )}
                <button onClick={handleLogout} className="text-gray-500 hover:text-red-500 font-medium">Sign Out</button>
              </>
            ) : (
              <>
                <Link to="/login" className="text-gray-600 hover:text-blue-600">Sign In</Link>
                <Link
                  to="/register"
                  className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 font-medium"
                >
                  Get Started Free
                </Link>
              </>
            )}
          </div>

          {/* Mobile toggle */}
          <button className="md:hidden p-2" onClick={() => setMobileOpen(!mobileOpen)}>
            {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="md:hidden border-t border-gray-200 bg-white px-4 py-3 space-y-2">
          {products.map(p => (
            <Link key={p.to} to={p.to} className="block py-2 text-gray-700" onClick={() => setMobileOpen(false)}>
              {p.label}
            </Link>
          ))}
          <Link to="/pricing" className="block py-2 text-gray-700" onClick={() => setMobileOpen(false)}>Pricing</Link>
          {user ? (
            <>
              <Link to="/dashboard" className="block py-2 text-gray-700" onClick={() => setMobileOpen(false)}>Dashboard</Link>
              {user.is_admin && (
                <Link to="/admin" className="block py-2 text-red-600 font-bold" onClick={() => setMobileOpen(false)}>Admin Panel</Link>
              )}
              <button onClick={handleLogout} className="block py-2 text-red-500 w-full text-left">Sign Out</button>
            </>
          ) : (
            <>
              <Link to="/login" className="block py-2 text-gray-700" onClick={() => setMobileOpen(false)}>Sign In</Link>
              <Link
                to="/register"
                className="block py-2 bg-blue-600 text-white text-center rounded-lg"
                onClick={() => setMobileOpen(false)}
              >
                Get Started Free
              </Link>
            </>
          )}
        </div>
      )}
    </nav>
  );
}
